import React from "react";
import ReactDOM from "react-dom";
import "mdb-react-ui-kit/dist/css/mdb.min.css";

// import App from "./App";
import JobCardSearch from "./App";

ReactDOM.render(<JobCardSearch />, document.getElementById("root"));
